/**
 * PropertyPhotoGalleryModal.tsx
 *
 * The standalone gallery, opened by clicking the cover photo on the property
 * page. It is only a shell now: the gallery itself lives in
 * PropertyPhotoGallery and is shared with the Rentmatch publication form
 * (DEV-3180).
 *
 * One action, Close. Uploads, deletes and the photo order all persist as they
 * happen, so there is nothing left for a save button to do.
 */

import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Modal } from "@rentiohq/web-shared/dist/components";
import React from "react";
import { PropertyPhotoGallery } from "./PropertyPhotoGallery";

interface IPropertyPhotoGalleryModalProps {
  propertyId: number;
  onClose: () => void;
  onSaved: () => void;
}

export const PropertyPhotoGalleryModal: React.FC<
  IPropertyPhotoGalleryModalProps
> = ({ propertyId, onClose, onSaved }) => (
  <Modal
    heading={getLocalizedText("property.gallery.modal.title")}
    onClose={onClose}
    actions={[
      {
        content: getLocalizedText("system.close"),
        onClick: onClose,
      },
    ]}
  >
    <PropertyPhotoGallery propertyId={propertyId} onSaved={onSaved} />
  </Modal>
);
